import { styled, Box, Typography } from "@mui/material";

export const SystemInformationItemWrapper = styled(Box)({
    display: "flex",
});

export const SystemInformationItemTitle = styled(Typography)({
    width: "120px",
});